import React from 'react';

import '@app/scss/components/customModal.scss';

interface CustomModalProps {
	modalVisible: boolean;
	setModalVisible: (e: boolean) => void;
}

const CustomModal: React.FC<CustomModalProps> = ({ modalVisible, setModalVisible, children }) => {
	return modalVisible ? (
		<div className="modal-wrapper" onClick={() => setModalVisible(false)}>
			<div className="modal-wrapper__content" onClick={(e) => e.stopPropagation()}>
				{children}
			</div>
		</div>
	) : null;
};

export default CustomModal;
